<template>
  <section class="locations-section">
    <div class="container">
      <div class="section-header">
        <div class="section-tag">
          <i :class="headerData.icon"></i>
          <span>{{ headerData.tag }}</span>
        </div>
        <h2>{{ headerData.title }}</h2>
        <p class="section-description">{{ headerData.description }}</p>
      </div>
      
      <div class="locations-grid">
        <div class="location-card" v-for="(location, index) in locationsData" :key="index">
          <div class="location-icon">
            <i :class="location.icon"></i>
          </div>
          <h3>{{ location.title }}</h3>
          <p>{{ location.description }}</p>
          <div class="location-stats">
            <span class="stat" v-for="(stat, statIndex) in location.stats" :key="statIndex">{{ stat }}</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ServiceItsLocationComp",
  props: {
    headerData: {
      type: Object,
      required: true,
      default: () => ({
        icon: "fas fa-map-marker-alt",
        tag: "OUR LOCATIONS",
        title: "Service Locations",
        description: "10+ Service Outlets Available in MP & Bihar. Expansion Coming Soon."
      })
    },
    locationsData: {
      type: Array,
      required: true,
      default: () => []
    }
  }
};
</script>

<style scoped>
/* Import Google Fonts */
@import url('https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap');

/* Import Flaticon */
@import '@/assets/scss/Flaticon.scss';

/* Locations Section */
.locations-section {
  padding: 100px 0;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
}

.section-header {
  text-align: center;
  margin-bottom: 60px;
}

.section-tag {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: linear-gradient(135deg, #dc3545, #c82333);
  color: white;
  padding: 8px 20px;
  border-radius: 25px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 20px;
}

.section-header h2 {
  font-size: 48px;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
}

.section-description {
  font-size: 18px;
  color: #6c757d;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
}

.locations-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 40px;
  margin-top: 50px;
}

.location-card {
  background: white;
  border-radius: 15px;
  padding: 40px 30px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.location-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}

.location-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #dc3545, #c82333);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  color: white;
  font-size: 32px;
}

.location-card h3 {
  font-size: 24px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 15px;
  font-family: 'Archivo', sans-serif;
}

.location-card p {
  font-size: 16px;
  color: #6c757d;
  margin-bottom: 20px;
  line-height: 1.6;
}

.location-stats {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.location-stats .stat {
  background: #f8f9fa;
  color: #dc3545;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
}
</style>
